import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Attachments.frontend.types'

@Injectable({ providedIn: 'root' })
export class Attachments_delete_attachment_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { entityType: string, attachmentId: number }): Promise<void> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.entityType)) {
      missingRequiredInParams.push('\'entityType\'');
    }
    if (isNil(inParams.attachmentId)) {
      missingRequiredInParams.push('\'attachmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Attachments/functions/delete_attachment_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

